import { useEffect, useState } from "react";
import { HeartPulse, LogOut, Clock } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Paywall from "@/components/Paywall";

export default function BillingGate({ children }) {
  const { user, logout } = useAuth();
  const [status, setStatus] = useState(null);

  const load = () => api.get("/billing/status").then((r) => setStatus(r.data)).catch(() => setStatus({ premium: false, role: user?.role }));
  useEffect(() => { load(); }, []); // eslint-disable-line

  if (!status) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FBFBF7]" data-testid="billing-loading">
        <div className="w-10 h-10 rounded-full border-4 border-[#EBF3FB] border-t-[#1E5AA8] animate-spin" />
      </div>
    );
  }

  if (status.premium) return children;

  // Assistant whose linked doctor hasn't subscribed — they can't pay themselves.
  if (status.role === "assistant") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#FBFBF7] p-6 text-center" data-testid="assistant-locked">
        <div className="w-14 h-14 rounded-2xl bg-amber-100 flex items-center justify-center mb-5">
          <Clock className="w-7 h-7 text-amber-600" />
        </div>
        <h2 className="font-display text-2xl font-bold text-slate-900">Subscription inactive</h2>
        <p className="text-slate-500 mt-3 max-w-md text-sm">
          Your doctor's MDvia Care subscription isn't active yet. Please ask the doctor you work with to subscribe, then sign in again.
        </p>
        <button data-testid="assistant-locked-logout" onClick={logout}
          className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-white bg-[#1E5AA8] hover:bg-[#123C73] px-5 py-2.5 rounded-xl">
          <LogOut className="w-4 h-4" /> Sign out
        </button>
        <div className="flex items-center gap-2 mt-8 text-slate-400">
          <HeartPulse className="w-4 h-4 text-[#1E5AA8]" /><span className="font-display font-bold text-[#123C73]">MDvia Care</span>
        </div>
      </div>
    );
  }

  return <Paywall onActivated={load} />;
}
